import { HttpInterceptorFn } from '@angular/common/http';
import { inject, untracked } from '@angular/core';
import { AuthenticationService } from '../../features/auth/services/auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthenticationService);

  const excludedEndpoints = ['connect/token'];
  const isExcluded = excludedEndpoints.some(url => req.url.includes(url));
  if (isExcluded) {
    return next(req);
  }

  untracked(() => auth.xPath.set(auth.xPath() + 1));

  if (!auth.isAuthenticated()) {
    auth.logout();
    return next(req);
  }

  const sessionId = sessionStorage.getItem('impersonation_session_id');

  const headers: Record<string, string> = {
    Authorization: `Bearer ${auth.getAccessToken()}`,
    'Access-Control-Allow-Origin': '*',
    'X-Generation': auth.xPath().toString(),
  };

  if (sessionId) {
    headers['X-Session-Id'] = sessionId;
  }

  const modified = req.clone({ setHeaders: headers });

  return next(modified);
};
